import React from 'react';
import { Card, CardContent, Button, Grid, CircularProgress } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { addChecklistForm } from 'utils/ProjectConfigurationUtil';
import { useAppContext } from 'hooks/useAppContext';
import { DropzoneArea } from 'material-ui-dropzone'
import MaterialTable from 'material-table';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { NotificationsSnackBar } from 'components/Shared/DynamicForm';

const AddChecklistForm = ({ callback: submitCallback }) => {
  const { selectedProject } = useAppContext();
  const { useState, useEffect } = React;
  const [descriptionStatus, setDescriptionStatus] = useState(true);
  const [data, setData] = useState([
  ]);
  const [checklistFiles, setChecklistFiles] = useState([
  ]);
  const [status, setStatus] = useState({}
  );


  const useStyles = makeStyles(theme => createStyles({
    previewChip: {
      minWidth: 160,
      maxWidth: 210
    },
  }));

  const classes = useStyles();



  const validate = (values) => {
    const errors = {};
    if (!values.value) {
      errors.value = 'File is Required';
    };
    if (values.TestType.length === 0) {
      errors.TestType = 'File Type is Required';
    };
    return errors;
  };

  const onSubmit = async (values, actions) => {
    let description = true
    data.forEach(function (arrayItem) {
      if (arrayItem.description === "")
        description = false
    });
    let result
    if (description) {
      result = await addChecklistForm(checklistFiles, data, selectedProject);
    } else {
      setStatus({ success: false, message: "Description missing", alertType: "fail" });
    }
    if (result && result.length > 0 && result[0].success) {
      //actions.resetForm();
      submitCallback();
    }
  }

  const handleChange = (files) => {
    setChecklistFiles(files)
    const newdt = []
    files.forEach(function (arrayItem) {
      const found = data.some(el => el.path === arrayItem.path);
      console.log(found)
      if (!found)
        newdt.push({ name: arrayItem.name, description: '', path: arrayItem.path })
    });

    setData([...data, ...newdt]);

    data.forEach(function (arrayItem) {
      const found = files.some(el => el.path === arrayItem.path);
      if (!found) {
        data.splice(arrayItem.tableData.id, 1);
        setData([...data]);
      }


    });



  }

  useEffect(() => {
    if (data.length > 0) {
      let description = true
      for (const arrayItem of data) {
        if (arrayItem.description === "")
          description = false
      }
      setDescriptionStatus(!description)
    }
  }, [data]);

  return (
    <Grid container justify="center" style={{ padding: 16, paddingLeft: 50, paddingRight: 50 }} spacing={3}>
      <Grid item xs={6}>
        <Editable />
      </Grid>
      <Grid item xs={6}> <DropzoneArea
        onChange={handleChange.bind(this)}
        style={{ width: "100%" }}
        showPreviews={false}
        showPreviewsInDropzone={true}
        useChipsForPreview
        previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
        previewChipProps={{ classes: { root: classes.previewChip } }}
        previewText="Selected files"
        filesLimit={5}
      /></Grid>
      <Card>
        <Formik
          validate={validate}
          initialValues={{
            value: null,
            TestType: '',
            Description: ''
          }}

        >
          {(params) => {
            return (
              <>
                {
                  !params.isSubmitting ? <Form>
                    <CardContent>
                    </CardContent>
                  </Form> : <CircularProgress></CircularProgress>
                }
              </>
            )
          }}
        </Formik>
        <NotificationsSnackBar status={status} setStatus={setStatus} refreshLagTime={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}></NotificationsSnackBar>
        <Button color="primary" type="submit" variant="contained" onClick={() => { onSubmit(); }} disabled={descriptionStatus ? "true" : ""} > Upload Field Form</Button>

      </Card>
    </Grid>
  )

  function Editable() {
    const { useState } = React;

    const [columns, setColumns] = useState([
      { title: 'FileName', field: 'name' },
      { title: 'Description*', field: 'description', initialEditValue: '' }
    ]);


    return (
      <MaterialTable
        title="Add Checklists"
        columns={columns}
        data={data}
        options={{
          search: false
        }}
        editable={{
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              console.log(newData)
              setTimeout(() => {
                const dataUpdate = [...data];
                const index = oldData.tableData.id;
                dataUpdate[index] = newData;
                setData([...dataUpdate]);
                resolve();
              }, 1000)
            })
        }}
      />
    )
  }

}

export default AddChecklistForm;